import clsx from 'clsx'
import React, { useState, useEffect } from 'react'

const Tabs = ({ options, onChange, large }) => {
  const [activeTab, setActiveTab] = useState(options[0].value)

  useEffect(() => {
    onChange(activeTab)
  }, [activeTab, onChange])

  return (
    <div className="flex border-b border-gray-300 mt-6 mb-2">
      {options.map(option => (
        <div
          className={clsx(
            'flex cursor-pointer text-lg font-semibold justify-center px-3 ml-6 text-gray-600',
            activeTab === option.value && 'border-b-2 border-green-600 text-gray-900'
          )}
        >
          <span
            onClick={() => setActiveTab(option.value)}
            className={clsx(activeTab !== option.value && 'text-gray-400', large && 'text-2xl font-semibold')}
          >
            {option.name}
          </span>
        </div>
      ))}
    </div>
  )
}

export default Tabs
